module.exports = __webpack_public_path__ + "img/play.2475d1d6.svg";